<template>
  <div class="animated fadeIn viatico-rendicion">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <div slot="header">Rendición de la Solicitud de Viaticos</div>
          <b-form>
            <b-form-group
              label="Importe"
              label-for="importe"
              :label-cols="labelCols">
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model"
                :state="importeValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols">
              <b-form-textarea
                id="observaciones"
                v-model.trim="$v.observaciones.$model"
                :state="observacionesValido"
                type="text"
                @blur.native="validate"
                rows="3"
                max-rows="6">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header="Rubros">
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy" 
              class="registro-ordenes"
              :items="rubros" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(importe)="data">
              <input type="number" step="0.01"
                  v-model="data.item.importe"
                  @focus="$event.target.select()"
                  @input="updateImporteRubro(data.item)"/>
            </template>
            <template v-slot:cell(comprobantes)="data">
              <input type="number" step="1"
                  v-model="data.item.comprobantes"
                  @focus="$event.target.select()"
                  @input="updateComprobantesRubro(data.item)"/>
            </template>
          </b-table>

          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy" 
              class="registro-ordenes totales"
              :items="totales" 
              :fields="fields">
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
// import FormattedCurrency from '../shared/formattedCurrency.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { maxLength, decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'viaticoRendicion/getField',
  mutationType: 'viaticoRendicion/updateField',
});

export default {
  name: 'ViaticosRendicion',
  components: {
    // appFormattedCurrency: FormattedCurrency,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      importeValido: null,
      importeInvalidoMsj: '',
      observacionesValido: null,
      observacionesInvalidoMsj: '',

      fields: [
        {
          key: 'nombre',
          label: 'Rubro',
        },
        {
          key: 'comprobantes',
          // label: 'Cant.Comprobantes',
        },
        {
          key: 'importe',
          class: 'text-right'
        },
      ],

      labelCols: 2,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      personalReadOnly: false,
      tableBusy: false
    }
  },
  computed: {
    ...mapFields([
      'importe',
      'observaciones',

      'rubros',
      'totalRubros'
    ]),
    totales() {
      return [
        {
          nombre: '',
          comprobantes: 'Total',
          importe: this.totalRubros
        }
      ]
    }
  },
  created() {
    let viaticoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        viaticoId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('viaticoRendicion/inicializar', viaticoId)
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());

  },
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal) {
            this.importeInvalidoMsj = 'El importe de la rendición debe ser un valor numérico';
          } else if (!this.$v.importe.minValue) {
              this.importeInvalidoMsj = 'El importe de la rendición no es válido';
          }     
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValido = false
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidoMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres.'
          }      
        } else {
          this.observacionesValido = null;
          this.observacionesInvalidoMsj = '';
        }
      }

    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('viaticoRendicion/save')
            .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: "Viaticos" });
    },
    updateImporteRubro(item) {
      this.$store.dispatch('viaticoRendicion/calcularTotalRubros')
        .catch( error => this.showErrorMsj (error));
    },
    updateComprobantesRubro(item) {
      
    },
  },
  /* Vuelidate */
  validations: {
    importe: {
      decimal,
      minValue: minValue(0)
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
  .viatico-rendicion .registro-ordenes table td {
    vertical-align: middle;
  }

  .viatico-rendicion .registro-ordenes table td[aria-colindex="1"] {
    width: 75%;
  }
  .viatico-rendicion .registro-ordenes table td[aria-colindex="2"] {
    width: 10%;
  }
  .viatico-rendicion .registro-ordenes table td[aria-colindex="3"] {
    width: 15%;
  }
  .viatico-rendicion .registro-ordenes table tr td {
    border-top: none;
  } 

  .viatico-rendicion .registro-ordenes.totales thead {
    display: none;
  }
  .viatico-rendicion .registro-ordenes.totales table tr td {
    font-weight: 700;
  }
</style>